export default "__VITE_ASSET__6dcfbde4__"